import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ShopContext } from '../Context/ShopContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(ShopContext);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
